<template>
  <div class="mt-2 flex w-full items-center gap-2">
    <div class="h-4 w-4 rounded-full bg-[#75B606]"></div>
    <span v-t="'pages.collection.stock.available'" class="font-extrabold" />
  </div>
</template>
